export default __webpack_public_path__ + "static/media/30_photo.1870e30d.jpg";